"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uiSelectors = require("../../store/ui/uiSelectors");
var _uiUtils = require("../../utils/uiUtils");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _constants = require("../../utils/constants");
var _useAppSelector = require("../useAppSelector");
const useCurrentPageContent = () => {
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const {
    contextMap
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  switch (contextMap) {
    case _constants.THEMES.ENTEL:
      return _uiUtils.ENTEL_CONTEXT_MAP[currentPage];
    case _constants.THEMES.MARKETPLACE:
      return _uiUtils.MARKETPLACE_CONTEXT_MAP[currentPage];
    case _constants.THEMES.GERMANY:
      return _uiUtils.GERMANY_CONTEXT_MAP[currentPage];
    case 'custom':
      return _uiUtils.CUSTOM_CONTEXT_MAP[currentPage];
    default:
      return _uiUtils.DEFAULT_CONTEXT_MAP[currentPage];
  }
};
var _default = useCurrentPageContent;
exports.default = _default;